import { render, staticRenderFns } from "./WatchLatest.vue?vue&type=template&id=3c3dbaec&"
import script from "./WatchLatest.vue?vue&type=script&lang=js&"
export * from "./WatchLatest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports